import React, { useEffect } from 'react'
import Button from '../../atoms/button/button'
import GenericModal from '../../organisms/generic-modal/generic-modal'
import './generic-response-modals.scss'

const GenericResponseModals = ({
  title,
  subtitle,
  note,
  image,
  closeModal,
  copyBtn,
  onClickBtn,
}) => {
  useEffect(() => {
    document.documentElement.style.overflowY = 'hidden'
    document.body.scroll = 'no'
    return () => {
      document.documentElement.style.overflowY = 'scroll'
      document.body.scroll = 'yes'
    }
  }, [])

  return (
    <GenericModal closeModal={closeModal}>
      <div className='f-m-generic-response-modals'>
        {image && (
          <div className='f-m-generic-response-modals__image'>
            <img src={image} alt='imagen de alerta' loading='lazy' />
          </div>
        )}
        <p
          className={
            'f-m-generic-response-modals__title ' + (title ? '' : '__hidden')
          }
        >
          {title ? title : ''}
        </p>
        <p
          className={
            'f-m-generic-response-modals__subtitle ' +
            (subtitle ? '' : '__hidden')
          }
        >
          {subtitle ? subtitle : ''}
        </p>
        <p
          className={
            'f-m-generic-response-modals__note ' + (note ? '' : '__hidden')
          }
        >
          {note ? note : ''}
        </p>

        <Button
          id='f-a-button__f-m-generic-response-modals'
          className='f-a-button__primary-purple f-a-button__extra-big'
          copy={copyBtn}
          onclick={onClickBtn}
        />
      </div>
    </GenericModal>
  )
}

export default GenericResponseModals
